import React, { FC } from 'react';
import { message } from 'antd';
import { api, endpoints } from '../../api';
import { CustomModal } from '../../styles/styled';

type ResetUserPasswordModalProps = {
  open: boolean;
  setOpen: () => void;
  id: number | string;
};

export const ResetUserPasswordModal: FC<ResetUserPasswordModalProps> = ({ open, setOpen, id }) => {
  const resetPassword = async () => {
    try {
      const response = await api.post(endpoints.changeUserPass(id));

      if (response) {
        message.success('Пароль эксперта успешно сброшен');
      }

      setOpen();
    } catch (err) {}
  };

  return (
    <CustomModal
      title="Вы уверены что хотите сменить пароль?"
      showCancelButton
      visible={open}
      onOk={resetPassword}
      cancelText="Отмена"
      okText="Сбросить"
      onCancel={setOpen}
    />
  );
};
